module.exports = __webpack_public_path__ + "media/11.87b1bb0b.mp3";